import { isString } from "lodash";
import { ActionHandler } from "../../../../types";

type PaymentSuccessResponse = {
	id: number;
	message: string;
	numeroControl: string;
	resultadoPayw?: string;
	data: string;
};

type PaymentErrorResponse = {
	id: number;
	message: string;
	numeroControl: string | null;
};

type PaymentFunctionParams = {
	Params: string;
	onError: ActionHandler<PaymentErrorResponse>;
	onClosed: ActionHandler<PaymentErrorResponse>;
	onCancel: ActionHandler<PaymentErrorResponse>;
	onSuccess: ActionHandler<PaymentSuccessResponse>;
};

type PaymentFunction = {
	startPayment: (options: PaymentFunctionParams) => void;
	setEnv: ActionHandler<string>;
};

declare const Payment: PaymentFunction;

export const setEnv = (mode: string) => {
	if (typeof Payment !== "undefined") {
		Payment.setEnv(mode);
	}
};

export const startPayment = (token: string): Promise<string> => {
	return new Promise((resolve, reject) => {
		if (typeof Payment === "undefined") {
			reject(new Error("No se pudo localizar el servicio de Ventana de Comercio"));
		}

		Payment.startPayment({
			Params: token,
			onError: function (response) {
				console.log("onError", response);
				reject(new Error(response.message));
			},
			onClosed: function (response) {
				console.log("onClosed", response);
				reject(new Error(response.message));
			},
			onCancel: function (response) {
				console.log("onCancel", response);
				reject(new Error("Pago no realizado, operación cancelada por el usuario."));
			},
			onSuccess: function (response) {
				console.log("onSuccess", response);
				if (isString(response.data)) {
					resolve(response.data);
				} else {
					reject(new Error(response.message));
				}
			}
		});
	});
};